import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { LoadUserAction } from './store/auth/auth.actions';
import { AuthDataState } from './store/auth/auth.reducer';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(public matIconRegistry: MatIconRegistry, private store: Store<AuthDataState>) {
    matIconRegistry.registerFontClassAlias('fa');
  }

  ngOnInit() {
    this.store.dispatch(new LoadUserAction());
  }
}
